import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SocialLinks from './SocialLinks';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/courses', label: 'Courses' },
  { to: '/placements', label: 'Placements' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const isActive = path => location.pathname === path;

  return (
    <>
      <header className={`nav-lux ${transparent ? 'nav-lux--transparent' : 'nav-lux--solid'}`}>
        <div className="nav-lux__inner">
          <Link to="/" className="nav-lux__brand">
            <img src="/logo.png" alt="" className="nav-lux__logo" />
            <span>Bharat Training</span>
          </Link>

          <nav className="nav-lux__links">
            {navLinks.map(l => (
              <Link
                key={l.to}
                to={l.to}
                className={`nav-lux__link ${isActive(l.to) ? 'nav-lux__link--active' : ''}`}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="nav-lux__right">
            <div className="nav-lux__social-desk">
              <SocialLinks size="sm" />
            </div>
            <a href="tel:+918851868521" className="nav-lux__phone hero__chip" style={{ fontSize: 12, padding: '8px 14px' }}>
              88518 68521
            </a>
            <Link to="/admission" className="btn-lux btn-lux--fill" style={{ padding: '12px 22px', fontSize: 10 }}>
              Apply
            </Link>
            <button
              type="button"
              className="nav-ham"
              onClick={() => setMenuOpen(open => !open)}
              aria-label="Menu"
              aria-expanded={menuOpen}
              style={{
                display: 'none',
                color: '#fff',
                padding: 10,
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: 8,
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {menuOpen ? <path d="M6 6l12 12M6 18L18 6" /> : <path d="M3 12h18M3 6h18M3 18h18" />}
              </svg>
            </button>
          </div>
        </div>
      </header>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="mobile-lux"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <button
              type="button"
              onClick={() => setMenuOpen(false)}
              style={{ position: 'absolute', top: 24, right: 24, color: '#fff', fontSize: 14, letterSpacing: '0.2em' }}
            >
              CLOSE
            </button>
            {navLinks.map((l, i) => (
              <motion.div key={l.to} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
                <Link to={l.to} className="mobile-lux__link">{l.label}</Link>
              </motion.div>
            ))}
            <div style={{ marginTop: 40 }}>
              <SocialLinks size="lg" />
            </div>
            <Link to="/admission" className="btn-lux btn-lux--fill" style={{ marginTop: 32, width: '100%', justifyContent: 'center' }}>
              Apply Now
            </Link>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        @media (max-width: 1024px) {
          .nav-lux__links { display: none !important; }
          .nav-lux__social-desk { display: none !important; }
          .nav-ham { display: flex !important; align-items: center; justify-content: center; }
        }
      `}</style>
    </>
  );
}
